// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"animationHeight--wrapper--3Qtqu_Y4"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/AnimationHeight/animationHeight.scss
// module id = 554
// module chunks = 0